(() => {
  if (window.beitoFitVideoControlsLoaded) return;
  window.beitoFitVideoControlsLoaded = true;

  const createVideo = player => {
    let video = player.querySelector('video');
    if (video) return video;
    const template = player.querySelector('template[data-fit-video-sources]');
    if (!template) return null;

    video = document.createElement('video');
    video.className = 'beito-fit__video-guide-video';
    video.setAttribute('playsinline', '');
    video.playsInline = true;
    video.preload = 'none';
    video.controls = false;
    video.disablePictureInPicture = true;
    video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
    video.muted = player.dataset.fitMuted === 'true';
    video.innerHTML = template.innerHTML;
    let closeButton = player.querySelector('[data-fit-video-exit-fullscreen]');
    if (!closeButton) {
      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'beito-fit__video-fullscreen-close';
      closeButton.setAttribute('aria-label', 'Vollbild schliessen');
      closeButton.dataset.fitVideoExitFullscreen = '';
      closeButton.textContent = '×';
      player.appendChild(closeButton);
    }
    video.addEventListener('play', () => syncPlayback(player, video));
    video.addEventListener('pause', () => syncPlayback(player, video));
    video.addEventListener('ended', () => syncPlayback(player, video));
    player.insertBefore(video, player.querySelector('[data-fit-video-play]'));
    player.classList.add('has-video');
    syncPlayback(player, video);
    return video;
  };

  const syncPlayback = (player, video) => {
    const playing = !video.paused && !video.ended;
    player.classList.toggle('is-playing', playing);
    const toggle = player.querySelector('[data-fit-video-toggle]');
    if (toggle) {
      toggle.textContent = playing ? 'Ⅱ' : '▶';
      toggle.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
    }
  };

  const enterFallbackFullscreen = player => {
    player.classList.add('is-fullscreen-fallback');
    document.documentElement.classList.add('beito-fit-fullscreen-open');
  };

  const exitFallbackFullscreen = player => {
    player.classList.remove('is-fullscreen-fallback');
    document.documentElement.classList.remove('beito-fit-fullscreen-open');
  };

  const closeMenu = menu => {
    const player = menu.__fitPlayer;
    if (!player) return;
    menu.hidden = true;
    menu.classList.remove('is-floating');
    menu.style.cssText = '';
    player.appendChild(menu);
    player.querySelector('[data-fit-video-menu]')?.setAttribute('aria-expanded', 'false');
  };

  const getMenu = player => Array.from(document.querySelectorAll('[data-fit-video-options]'))
    .find(menu => menu.__fitPlayer === player) || player.querySelector('[data-fit-video-options]');

  const closeAllMenus = () => {
    document.querySelectorAll('[data-fit-video-options]').forEach(menu => {
      if (!menu.hidden) closeMenu(menu);
    });
  };

  const openMenu = (player, button) => {
    closeAllMenus();
    const menu = getMenu(player);
    if (!menu) return;
    menu.__fitPlayer = player;
    document.body.appendChild(menu);
    const fullscreenOption = menu.querySelector('[data-fit-video-fullscreen]');
    if (fullscreenOption) fullscreenOption.textContent = player.classList.contains('is-fullscreen-fallback') || document.fullscreenElement === player ? 'Vollbildschirm verlassen' : 'Vollbildschirm ansehen';
    const rect = button.getBoundingClientRect();
    const width = Math.min(220, Math.max(120, window.innerWidth - 24));
    const left = Math.max(12, Math.min(rect.right - width, window.innerWidth - width - 12));
    const top = Math.max(12, Math.min(rect.bottom + 4, window.innerHeight - 108));
    menu.style.width = width + 'px';
    menu.style.left = left + 'px';
    menu.style.top = top + 'px';
    menu.classList.add('is-floating');
    menu.hidden = false;
    button.setAttribute('aria-expanded', 'true');
  };

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest('[data-dogs-close], [data-dogs-cancel], [data-dogs-guest], [data-dogs-shade], [aria-label="Schliessen"]')) {
      closeAllMenus();
    }
  }, true);

  document.addEventListener('contextmenu', event => {
    const target = event.target instanceof Element ? event.target : null;
    const player = target?.closest('.beito-fit__video-player');
    if (!player) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const options = target.closest('[data-fit-video-options]');
    const player = target.closest('.beito-fit__video-player') || options?.__fitPlayer;
    if (!player) {
      closeAllMenus();
      return;
    }

    const menuButton = target.closest('[data-fit-video-menu]');
    if (menuButton) {
      const menu = getMenu(player);
      if (menu && !menu.hidden) closeMenu(menu);
      else openMenu(player, menuButton);
      return;
    }

    const exitFullscreenButton = target.closest('[data-fit-video-exit-fullscreen]');
    if (exitFullscreenButton) {
      const video = player.querySelector('video');
      video?.pause();
      exitFallbackFullscreen(player);
      if (document.fullscreenElement === player) document.exitFullscreen?.().catch(() => {});
      return;
    }

    const fullscreenButton = target.closest('[data-fit-video-fullscreen]');
    if (fullscreenButton) {
      if (options) closeMenu(options);
      const video = createVideo(player);
      if (!video) return;
      if (document.fullscreenElement === player || player.classList.contains('is-fullscreen-fallback')) {
        exitFallbackFullscreen(player);
        if (document.fullscreenElement === player) document.exitFullscreen?.().catch(() => {});
        return;
      }
      const playVideo = () => video.play().catch(() => {});
      const useNativeVideoFullscreen = () => {
        if (typeof video.webkitEnterFullscreen !== 'function') return false;
        try { video.webkitEnterFullscreen(); playVideo(); return true; } catch (error) { return false; }
      };
      const request = player.requestFullscreen?.();
      if (request?.then) {
        request.then(playVideo).catch(() => {
          if (!useNativeVideoFullscreen()) enterFallbackFullscreen(player);
          playVideo();
        });
      } else if (!useNativeVideoFullscreen()) enterFallbackFullscreen(player);
      playVideo();
      return;
    }

    const muteButton = target.closest('[data-fit-video-mute]');
    if (muteButton) {
      const muted = player.dataset.fitMuted !== 'true';
      player.dataset.fitMuted = String(muted);
      const video = player.querySelector('video');
      if (video) video.muted = muted;
      muteButton.textContent = muted ? 'Ton einschalten' : 'Stummschalten';
      const menu = getMenu(player);
      if (menu) { menu.querySelector('[data-fit-video-mute]').textContent = muted ? 'Ton einschalten' : 'Stummschalten'; closeMenu(menu); }
      return;
    }

    const playButton = target.closest('[data-fit-video-play]');
    const toggleButton = target.closest('[data-fit-video-toggle]');
    const tappedVideo = target.closest('.beito-fit__video-player video');
    if (playButton || toggleButton || tappedVideo) {
      const video = createVideo(player);
      if (!video) return;
      if (video.paused) video.play().catch(() => {});
      else video.pause();
      return;
    }

    closeAllMenus();
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeAllMenus();
      document.querySelectorAll('.beito-fit__video-player.is-fullscreen-fallback').forEach(exitFallbackFullscreen);
    }
  });
  document.addEventListener('scroll', closeAllMenus, true);
  window.addEventListener('resize', closeAllMenus);
})();